import createSelector from "../../utils/reselect";

const shiftStateData = (state) => {
  const { shifts } = state;
  return shifts || {};
};

export const shiftsLoading = createSelector(shiftStateData, (shift) =>
  shift.get("pageLoading")
);

export const loader = createSelector(shiftStateData, (shift) =>
  shift.get("loading")
);

export const shifts = createSelector(shiftStateData, (shift) =>
  shift.get("shifts")
);

export const shiftsPagination = createSelector(shiftStateData, (shift) =>
  shift.get("shiftsPagination")
);

export const error = createSelector(shiftStateData, (shift) =>
  shift.get("error")
);
